import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'
import TagSelect from '../../../../../../../containers/tags/select/TagSelect'

const TagsSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChangeOnPath } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  return (
    <>
      <Separator weight={6} />
      <Title size="h6" color={COLORS.dark4}>
        {t('configurationTags')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={2} />

      <TagSelect
        onChange={handleSelectedQuestionChangeOnPath(['tags'])}
        value={selectedQuestion.tags}
        multiple
        type="question"
      />
    </>
  )
}

export default TagsSection
